import Footer from 'csdd_components/Footer';
import GalleryCompo from 'csdd_components/GalleryCompo';
import GalleryHeader from 'csdd_components/GalleryHeader';
import HomeNavBar from 'csdd_components/HomeNavBar';
import Newsletter from 'csdd_components/Newsletter';
import TopNavBar from 'csdd_components/TopNavBar';

const Gallery = () => {
  return (
    <>
      <TopNavBar />
      <HomeNavBar />
      <GalleryHeader />
      <GalleryCompo />
      <Newsletter />
      <Footer />
    </>
  );
};
export default Gallery;
